import React, { Component } from 'react'
import {Tabs, Tab} from 'material-ui/Tabs';

export default class TeamsTabs extends Component {

    componentDidMount() {

        this.props.setSelectedTabId(1);
    }

    render() {
    
       const tabStyleProps = {
            className: `tab-dialog`,
            buttonStyle: { color: '#372f51' },
            style: {backgroundColor: '#fff'}
        };

        return (
            <div>
                <Tabs className='tabs-dialog' contentContainerClassName='tabs-dialog-content-wrapper'>
                    {
                        this.props.tabs.map((tab, index) => {
                            return <Tab
                                    key={index} {...tabStyleProps} 
                                    value={tab.id}
                                    className={`tab-dialog${this.props.selectedTabId == tab.id 
                                        ? ' selected' : ''}`}
                                    label={tab.title}
                                    data-route={tab.route}
                                    onActive={this.props.handleActive}
                                    data-cy={`team-tab-${tab.id}`}>
                                    {tab.component}
                                </Tab>
                        })
                    }
                </Tabs>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/teams/teamsTabs/teamsTabs.jsx